// extracted by mini-css-extract-plugin
export default {"tabsList":"summaryTaskContent_tabsList__57jF5","tabs":"summaryTaskContent_tabs__fbVaG","growthBlock":"summaryTaskContent_growthBlock__leflZ"};